import { Component, OnInit, Input } from '@angular/core';
import { RouterService } from '../../../service/core/router.sevice';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store/app-state';
import { mainSetPageAction } from '../../../../store/main/index';

@Component({
  selector: 'app-mainbar-option',
  templateUrl: './mainbar-option.component.html',
  styleUrls: ['./mainbar-option.component.scss']
})
export class MainbarOptionComponent implements OnInit {

  @Input()
  icon: string = 'star';
  @Input()
  label: string;
  @Input()
  path: string;

  selected

  constructor(
    private store: Store<AppState>,
    private routerService: RouterService
  ) {
    this.store.subscribe(state => {
      this.selected = state.main.page.label === this.label
    });
  }

  ngOnInit() {
  }

  go() {
    this.routerService.go(this.path);
    this.store.dispatch(mainSetPageAction({ label: this.label }));
  }

}



// WEBPACK FOOTER //
// ./src/app/core/component/core/mainbar-option/mainbar-option.component.ts